/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterUserIntentKind = (typeof FilterUserIntentKind)[keyof typeof FilterUserIntentKind];

export const FilterUserIntentKind = {
  user_intent: 'user_intent',
} as const;
